module.exports = __webpack_public_path__ + "public/img/dev-bg1.c9477834.png";